import { getPerils } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
import { isEmpty } from 'lodash';

export const useGetPerils = (tenantId: string, enabled = true) => {
  const { data, status, refetch } = useQuery(
    ['perils'],
    () => getPerils(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    perils: data || [],
    perilsStatus: status,
    fetchPerils: refetch,
  };
};
